import React from 'react';
import { SEOTableData } from 'src/api/models/SEOTable';
import { SEOTableContainer } from './SEOTable.styles';
import { Color } from 'src/styles/colors';
import Head from './Head';
import Body from './Body';

type SEOTableProps = SEOTableData;

const DEFAULT_BACKGROUND_COLOR_SET: Color[] = ['white', () => 'rgba(20, 25, 33, 0.05)'];
const DEFAULT_BORDER_COLOR: Color = () => 'rgba(20, 25, 33, 0.2)';
const DEFAULT_TEXT_COLOR: Color = 'greyText';

const SEOTable = ({
  head,
  table,
  borderColor = DEFAULT_BORDER_COLOR,
  textColor = DEFAULT_TEXT_COLOR,
  backgroundColorSet = DEFAULT_BACKGROUND_COLOR_SET,
  checkIconSet = 'check-unckeck',
  firstColumnCustomWidth,
}: SEOTableProps): JSX.Element => {
  const columnCount = head.length + 1;

  const configProps = {
    columnCount,
    backgroundColorSet,
    borderColor,
    textColor,
    checkIconSet,
    firstColumnCustomWidth,
  };

  return (
    <SEOTableContainer borderColor={borderColor}>
      <Head
        head={head}
        {...configProps}
      />
      <Body
        table={table}
        {...configProps}
      />
    </SEOTableContainer>
  );
};

export default SEOTable;
